export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14687.82ee6e4f.jpg";